export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -09.0e14727a.png";